import { reduceFraction } from './number.esm.js';

/**
 * Sum all numbers in an array
 * @param array An array of numbers to sum
 */

function sumArray(array) {
  return array.reduce(function (acc, val) {
    return acc + val;
  }, 0);
}
/**
 * Reduce a fraction
 * @param array [numerator, denominator]
 */

function reduceFractionArray(array) {
  var numerator = array[0],
      denominator = array[1];
  return reduceFraction(numerator, denominator);
}
function addItem(array, item) {
  return [].concat(array, [item]);
}
function removeItem(array, item) {
  return array.filter(function (eachItem) {
    return eachItem !== item;
  });
}
/**
 * Get the next index based on the current index and step.
 *
 * @param currentIndex the current index
 * @param length the total length or count of items
 * @param step the number of steps
 * @param loop whether to circle back once `currentIndex` is at the start/end
 */

function getNextIndex(currentIndex, length, step, loop) {
  if (step === void 0) {
    step = 1;
  }

  if (loop === void 0) {
    loop = true;
  }

  var lastIndex = length - 1;

  if (currentIndex === -1) {
    return step > 0 ? 0 : lastIndex;
  }

  var nextIndex = currentIndex + step;

  if (nextIndex < 0) {
    return loop ? lastIndex : 0;
  }

  if (nextIndex >= length) {
    if (loop) return 0;
    return currentIndex > length ? length : currentIndex;
  }

  return nextIndex;
}
/**
 * Get's the previous index based on the current index.
 * Mostly used for keyboard navigation.
 *
 * @param index - the current index
 * @param count - the length or total count of items in the array
 * @param loop - whether we should circle back to the
 * first/last once `currentIndex` is at the start/end
 */

function getPrevIndex(currentIndex, count, loop) {
  if (loop === void 0) {
    loop = true;
  }

  return getNextIndex(currentIndex, count, -1, loop);
}
function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
  if (!searchString) return null; // If current value doesn't exist, find the item that match the search string

  if (!currentItem) {
    var foundItem = items.find(function (item) {
      return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    });
    return foundItem || currentItem;
  } // Filter items for ones that match the search string (case insensitive)


  var searchResults = items.filter(function (item) {
    return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
  }); // If there's a match, let's get the next item to select

  if (searchResults.length) {
    var nextIndex; // If the currentItem is in the available items, we move to the next available option

    if (searchResults.includes(currentItem)) {
      var currentIndex = searchResults.indexOf(currentItem);
      nextIndex = currentIndex + 1;

      if (nextIndex === searchResults.length) {
        nextIndex = 0;
      }

      return searchResults[nextIndex];
    } // Else, we pick the first item in the available items


    nextIndex = items.indexOf(searchResults[0]);
    return items[nextIndex];
  } // a decent fallback to the currentItem


  return currentItem;
}

export { addItem, getNextIndex, getNextItemFromSearch, getPrevIndex, reduceFractionArray, removeItem, sumArray };
//# sourceMappingURL=array.esm.js.map
